import PageHeader from "Components/Pages/Header";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { MainContent, PageContainer, PageContent } from "./styles";
import { ValidationRangeCep } from "./components/ValidationRangeCep";

const Schedule = () => {
  return (
    <PageContainer className="entry-app-content entry-budget">
      <PageContent>
        <div className="page-heading">
          <div className="wrapper-header-content">
            <PageHeader title="Busca agendas">
              <Breadcrumb
                list={[
                  {
                    path: "#",
                    label: "Agendas",
                    current: false,
                  },
                ]}
              />
            </PageHeader>
          </div>
        </div>
        <div className="separator" />
      </PageContent>

      <MainContent>
        <h2 className="text-center text-centered text-purple section-title">
          Confira se o CEP está coberto por nossa agenda.
        </h2>

        <div className="zipcode">
          <ValidationRangeCep />
        </div>
      </MainContent>
    </PageContainer>
  );
};

export default Schedule;
